







import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { auth } from '../auth/AuthService';

@Component({
})
export default class AuthCallback extends Vue {
  // @Prop() auth: any;

  mounted() {
    console.log(`[AuthCallback] mounted`);
    auth.handleAuthentication();
  }

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AuthCallback.vue